import { injectable } from 'inversify';

@injectable()
export class CsvGeneratorService {
  /**
   * utf-8 bom (byte order mark)
   * le bom doit être ajouté en début de csv pour que microsoft excel détecte correctement les fichiers csv en encodage UTF-8 (et affiche les caractères spéciaux)
   * le bom ajouté automatiquement côté back est supprimée lorsque le blob est converti en texte
   */
  static BOM = '\uFEFF'; // utf-8 BOM (byte order mark)

  public async generateCsvContent(getCsvPart: (page: number) => Promise<Blob> | Error): Promise<Blob> {
    async function* iterateOverAllCsv(getCsvPart: (page: number) => Promise<Blob> | Error): AsyncIterable<string> {
      async function* iterateOverCsv(page: number): AsyncIterable<string> {
        const result = await getCsvPart(page);
        if (result instanceof Error) {
          throw result;
        }

        const text = await result.text(); // /!\ looses potential bom

        const content = text
          .split('\n')
          .slice(page === 1 ? 0 : 1)
          .filter((line) => line.length)
          .join('\n');

        const hasContent = content.trim().length > 0;
        yield hasContent ? `${content}\n` : '';

        if (hasContent) {
          yield* iterateOverCsv(page + 1);
        }
      }

      yield* iterateOverCsv(1);
    }

    const blobParts = iterateOverAllCsv(getCsvPart);
    let contents = '';
    for await (const blobPart of blobParts) {
      contents += blobPart;
    }

    return new Blob([CsvGeneratorService.BOM + contents], { type: 'text/csv;charset=utf-8' });
  }
}
